import React, { useState } from "react";
import { isMobile, isTablet } from "react-device-detect";

import Box from "@mui/material/Box";

import BankItem from "../BankItem";
import MonobankModal from "../MonobankModal";
import WorkInProgressModal from "components/WorkInProgressModal";

import { useAppDispatch } from "store/hooks";
import { initMonobankIntegration } from "store/features/bankIntegrationsSlice";

import { BankTokenAddMonobankResponseDto } from "api";

import { ReactComponent as MonobankIcon } from "assets/images/bankIntegrations/mono.svg";
import { ReactComponent as Privat24Icon } from "assets/images/bankIntegrations/privat24.svg";

const IntegrationBanks: React.FC = () => {
  const dispatch = useAppDispatch();

  const [monobankResponse, setMonobankResponse] =
    useState<BankTokenAddMonobankResponseDto | null>(null);
  const [isProgressModalOpen, setIsProgressModalOpen] = useState(false);

  const onMonobankConnect = async () => {
    const response = await dispatch(initMonobankIntegration()).unwrap();

    setMonobankResponse(response);

    if (isMobile || isTablet) {
      window.location.assign(response.monobankAcceptUrl);
    }
  };

  const onMonobankModalClose = () => {
    setMonobankResponse(null);
  };

  const onPrivatBankConnect = () => {
    setIsProgressModalOpen(true);
  };

  const onWorkInProgressModalClose = () => {
    setIsProgressModalOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          width: "100%",
          gap: 2,
          mb: 3,
        }}
      >
        <BankItem
          title="Monobank"
          icon={<MonobankIcon />}
          onClick={onMonobankConnect}
        />
        <BankItem
          title="PrivatBank"
          icon={<Privat24Icon />}
          onClick={onPrivatBankConnect}
        />
      </Box>
      <MonobankModal
        isOpen={!!monobankResponse?.monobankAcceptUrl}
        onClose={onMonobankModalClose}
        monobankInfo={monobankResponse}
      />
      <WorkInProgressModal
        source="Privat24 інтеграція"
        isOpen={isProgressModalOpen}
        closeModal={onWorkInProgressModalClose}
      />
    </>
  );
};

export default IntegrationBanks;
